<script lang="ts"></script>

<div data-component="Layout" class="wrapper">
  <slot />
</div>

<style src="./styles.scss"></style>
